import React from 'react';
import {
  Anchor,
  DialogActions,
  Heading,
  IconHelpOutline,
  Paragraph,
  Popover,
  Popper,
  spaceMixin,
  Spacer,
} from '@zillow/constellation';
import { URLS } from '../../../../constants/urls';
import styled from 'styled-components';

const StyledSpacer = styled(Spacer)`
  cursor: pointer;
  display: inline;
  position: relative;
  top: ${spaceMixin(0.5)};
`;

export default function EnrollmentTooltip() {
  return (
    <Popper
      triggered={
        <Popover
          header={<Heading level={6}>Zillow Applications</Heading>}
          body={
            <>
              <Paragraph>
                When applications are <b>enabled</b>, renters can apply directly from your listing using Zillow's
                application and screening platform.
              </Paragraph>
              <Paragraph marginTop="sm">
                When applications are <b>disabled</b>, renters can request to apply online, or you can use your own
                application form.
              </Paragraph>
              <DialogActions>
                <Anchor href={URLS.MARKETING_LANDING_PAGE} target="_blank">
                  Learn more about Zillow applications
                </Anchor>
              </DialogActions>
            </>
          }
        />
      }
    >
      <StyledSpacer marginLeft={0.5} role="button" aria-label="enable applications learn more">
        <IconHelpOutline fontColor="brand" />
      </StyledSpacer>
    </Popper>
  );
}
